// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { ORASDomainKey, ORASDomainSummaryField } from "../components/OffenderAssessment/utils";

// Default value for Criminal History - don't count this as "user has started"
export const CRIMINAL_HISTORY_DEFAULT =
  "The defendant's complete criminal history is attached to this report.";

// Map domain keys to their summary fields
export const DOMAIN_TO_SUMMARY_FIELD: Record<ORASDomainKey, ORASDomainSummaryField> = {
  criminalHistory: "criminalHistorySummary",
  educationEmployment: "employmentSummary",
  familySocialSupport: "familyAndSocialSupportSummary",
  neighborhoodProblems: "housingSummary",
  substanceUse: "drugHistorySummary",
  peerAssociates: "peerAssociatesSummary",
  criminalAttitudes: "criminalAttitudesSummary",
  responsivity: "responsivityAndBarriersSummary",
};
